import { NgModule } from '@angular/core';
import { Routes, RouterModule, Router } from '@angular/router';
import { GroupsComponent } from './groups.component';

const routes: Routes = [
  { path: '', component: GroupsComponent },
  // { path: ":id", component: ReferencesEditComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GroupsRoutingModule { }
